export const LEGAL_FORM_LIST_LOAD = "LEGAL_FORM_LIST_LOAD"; 
